import { detectIncompatibleBrowsers } from 'helpers/common';
import * as React from 'react';
import { browserHistory } from 'react-router';
require('./style.css');

class PortalLeftNavigation extends React.Component<any, any> {
	public currentElement: HTMLElement = undefined;
	public portalNavHolder: HTMLElement = undefined;

	constructor(props) {
		super(props);

		this.onLinkClick = this.onLinkClick.bind(this);
	}

	public componentDidMount() {
		this.portalNavHolder = document.getElementById('portalNavHolder');
	}

	private onLinkClick(val: any, isAnchorLink: boolean) {
		if (isAnchorLink) {
			this.currentElement = document.getElementById(val);
			this.currentElement.scrollIntoView({ block: 'start', inline: 'start' });
			const currentScrollY = window.scrollY;

			if (detectIncompatibleBrowsers()) {
				document.body.scrollTo(0, currentScrollY - (this.portalNavHolder.offsetHeight + 20));
			} else {
				window.scrollTo(0, currentScrollY - (this.portalNavHolder.offsetHeight + 20));
			}
		} else {
			browserHistory.push(val);
		}
	}

	public render() {
		const { items } = this.props;

		const links = items.map((item: any, index: number) => {
			const itemClass = 'leftNavigationItem';

			return (
				<div
					key={`leftNavigationItem${index}`}
					className={itemClass}
					onClick={() => this.onLinkClick(item.value, item.isAnchorLink)}
				>
					{item.text}
				</div>
			);
		});

		return (
			<div className="leftNavigationBox">
				{links}
				<div className="clear" />
			</div>
		);
	}
}
export { PortalLeftNavigation };
